export const observationsSectionInitValue = {
  data: {
    observations: [],
    observationsTotal: 0,
    page: 1,
    rowsPerPage: 10,
    isAdmin: false,
    isReadOnly: false,
    isLoadingObservations: false,
    isLoading: false,
  },
  actions: {
    handleChangePage: () => {},
    handleChangeRowsPerPage: () => {},
    handleAddObservation: () => {},
    handleEditObservation: () => {},
    handleDeleteObservation: () => {},
  },
};
